import { useState, useEffect } from 'react';
import axios from 'axios';
import AdminBackButton from '../components/AdminBackButton';

const API_URL = '/backend/api/';

function AdminTeams() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTeams = async () => {
    try {
      const res = await axios.get(`${API_URL}get_teams_online.php`);  // Hergebruik het online endpoint
      if (res.data.success) {
        setTeams(res.data.teams);
      }
    } catch (err) {
      alert('Fout bij ophalen teams');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeams();
    const interval = setInterval(fetchTeams, 10000); // Elke 10 sec updaten
    return () => clearInterval(interval);
  }, []);

  const copyAllCodes = () => {
    const codes = teams.map(t => t.code).join('\n');
    navigator.clipboard.writeText(codes);
    alert('Alle codes gekopieerd!');
  };

  const getStatusColor = (status) => {
    if (status === 'online') return 'bg-green-500';
    if (status === 'recent') return 'bg-yellow-400';
    return 'bg-red-500';
  };

  const getStatusText = (status, minutesAgo) => {
    if (status === 'online') return 'Online';
    if (status === 'recent') return `Recent (${minutesAgo} min geleden)`;
    return `Offline (${minutesAgo === null ? 'nooit' : minutesAgo + ' min geleden'})`;
  };

  if (loading) return <div className="p-8 text-center text-xl">Laden...</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8">Teams & Toegangscodes</h1>
<AdminBackButton />
        <div className="mb-6 text-center">
          <button
            onClick={copyAllCodes}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-bold mr-4"
          >
            Kopieer alle codes
          </button>
          <button
            onClick={fetchTeams}
            className="bg-gray-600 hover:bg-gray-700 text-white px-8 py-3 rounded-lg font-bold"
          >
            Vernieuwen
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-4 text-left">Code</th>
                <th className="p-4 text-left">Teamnaam</th>
                <th className="p-4 text-left">Laatst actief</th>
                <th className="p-4 text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {teams.length === 0 ? (
                <tr>
                  <td colSpan="4" className="p-8 text-center text-gray-500">
                    Geen teams gevonden
                  </td>
                </tr>
              ) : (
                teams.map((team, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="p-4 font-mono text-lg font-bold">{team.code}</td>
                    <td className="p-4 font-medium">{team.name}</td>
                    <td className="p-4">{team.last_active}</td>
                    <td className="p-4 text-center">
                      <div className={`inline-block px-5 py-2 rounded-full text-white font-bold ${getStatusColor(team.status)}`}>
                        {getStatusText(team.status, team.minutes_ago)}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center text-gray-600">
          <p>Totaal: {teams.length} teams</p>
          <p className="text-sm mt-2">
            Live bijgewerkt elke 10 seconden
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminTeams;